import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import axios from "axios";
const APIURL = process.env.REACT_APP_API_URL_LOCAL;

export const fetchplaylists = createAsyncThunk(
    "fetchplaylists",
    async ({ headers, params }) => {
        const config = {
            headers: { ...headers },
            params: params
        }
        try {
            const data = await axios.get(`${APIURL}/playlists/list`, config)
            return data

        } catch (error) {
            return error

        }
    }
);

export const fetchplaylistDetail = createAsyncThunk(
    "fetchplaylistDetail",
    async ({ headers, params }) => {
        const config = {
            headers: { ...headers }
        }
        try {
            const data = await axios.get(`${APIURL}/playlists/${params.playlistId}/view`, config)
            return data

        } catch (error) {
            return error

        }
    }
);

export const playlistSlice = createSlice({
    name: "playlist",
    initialState: {
        playlists: [],
        total: 0,
        limit: 10,
        page: 1,
        playlistDetail: {}
    },
    reducers: {
        changeLimit: (state, action) => {
            state.limit = action.payload;
        },
        changePage: (state, action) => {
            state.page = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchplaylists.fulfilled, (state, action) => {
            if (action?.payload.status == 403) {
                localStorage.removeItem("token");
                localStorage.removeItem("userData");
            }
            if (action?.payload?.data?.success) {
                state.playlists = action?.payload?.data?.result.playlists;
                state.total = action?.payload?.data?.result.total;
            }
        });

        builder.addCase(fetchplaylistDetail.fulfilled, (state, action) => {
            if (action?.payload.status == 403) {
                localStorage.removeItem("token");
                localStorage.removeItem("userData");
            }
            console.log(action)
            if (action?.payload?.data?.success) {
                state.playlistDetail = action?.payload?.data?.result;
            }
        });

    },
});

export const { changeLimit, changePage } = playlistSlice.actions;
export default playlistSlice.reducer;

export const playlistSelector = createSelector(
    (state) => state.playlist.playlists,
    (state) => state.playlist.total,
    (state) => state.playlist.limit,
    (state) => state.playlist.page,
    (state) => state.playlist.playlistDetail,
    (playlists, total, limit, page, playlistDetail) => ({
        playlists, total, limit, page, playlistDetail
    })
);

